import React, { useState } from 'react'
import { Button, Col, Modal, OverlayTrigger, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import { useFormik } from 'formik'

import { toast } from 'react-toastify';
import { addCustomerAddress, editCustomerAddress } from 'utlis/Apis/Customers_API';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import FormCustomersAddress from './FormCustomers__Address';
import { ADDRESS_ADDED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING_ADDRESS } from 'utlis/AppMessages/AppMessages';
import { createCustomerFormValidationSchema, initialValues } from '../formHelper';
import { connect } from 'react-redux';
import { setGlobalLoading } from 'redux/actions/actionCommon'

function CustomerAddressModal(props) {
    const { authState, show, closeModal, onSave, addressData, countries, getCustomerAddresses_, id, customer } = props
    const [modalLoading, setModalLoading] = useState(false)

    const [createCustomerButtonDisable, setCreateCustomerButtonDisable] = useState(false)

    const onCreateCustomerFormSubmit = values => {
        if (values) {
            setModalLoading(true)
            setCreateCustomerButtonDisable(true)
            values.user_id = props.userId
            if (values.address_id) {
                const headers = {
                    "Authorization": `Bearer ${authState.commonToken}`,
                    "Api-Token": authState.apiToken,
                    "Access-Token": "",
                    // "Store-Id": authState.storeId,
                }
                editCustomerAddress(headers, values).then(res => {
                    setCreateCustomerButtonDisable(false)
                    onSuccess(res)
                }).catch(err => {
                    onError(err)
                    setCreateCustomerButtonDisable(false)
                })
            } else {
                const headers = {
                    "Authorization": `Bearer ${authState.commonToken}`,
                    "Api-Token": authState.apiToken,
                    "Access-Token": "",
                    // "Store-Id": authState.storeId,
                }
                addCustomerAddress(headers, values).then(res => {
                    setCreateCustomerButtonDisable(false)
                    onSuccess(res)

                }).catch(err => {
                    onError(err)
                    setCreateCustomerButtonDisable(false)
                })
            }
        }
    }
    const onError = (err) => {
        console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
        toast.dismiss();
        setModalLoading(false)
        setCreateCustomerButtonDisable(false)
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setCreateCustomerButtonDisable(false)
            }
        })
    }
    const onSuccess = (res) => {
        const customerAddress = res.data
        if (customerAddress.success) {
            onSave()
            formik.resetForm()
            closeModal()
            toast.dismiss();
            toast.success(ADDRESS_ADDED_SUCCESSFULLY, {
                autoClose: 2000,
                onClose: () => {
                }

            })
            closeModal(!show)
        }

        if (customerAddress.error) {
            setModalLoading(false)
            setCreateCustomerButtonDisable(false)

            console.log(ERROR_WHILE_CREATING_ADDRESS, res)
            setModalLoading(false)

            setCreateCustomerButtonDisable(false)
            // setCreateButtonLoading(false)
            toast.dismiss();
            toast.error(ERROR_WHILE_CREATING_ADDRESS, {
                autoClose: 3000,
            })
        }
    }

    const formik = useFormik({
        initialValues: initialValues(addressData, customer),
        validationSchema: createCustomerFormValidationSchema,
        onSubmit: onCreateCustomerFormSubmit,
        enableReinitialize: true
    })

    return (
        <Modal show={show} onHide={closeModal} centered size="lg">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal_add-customer p-0">
                    <div className="add-customer-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title text-capitalize st-fw-600">{addressData.address_id ? "Edit Address" : "Add address"}</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <Button
                                    className="st-round-btn st-btn-transparent  st-btn-sm p-0 d-flex align-items-center justify-content-center"
                                    onClick={props.closeModal && props.closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card customer-address-modal" >
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <Col xs={12} md={12} lg={12} className="px-0">
                                    <form
                                        onSubmit={formik.handleSubmit}
                                        noValidate
                                        autoComplete="off">
                                        <Col xs={12} md={9} lg={12} className=" pad-20-R pad-20-L">
                                            <FormCustomersAddress
                                                authState={authState}
                                                getCustomerAddresses_={() => {
                                                    getCustomerAddresses_(id)
                                                }}
                                                address={addressData}
                                                countries={countries}
                                                formik={formik} />
                                        </Col>

                                        <div className="btns d-flex justify-content-end pt-3">
                                            <Button
                                                onClick={() =>
                                                    (formik.resetForm())}
                                                className="st-btn st-btn-gray no-min-width d-flex align-items-center justify-content-center me-2">
                                                <FeatherIcon
                                                    icon="rotate-cw"
                                                    size="14"
                                                    className="icon me-2" />
                                                <span className="text-uppercase">Reset</span>
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="st-btn st-btn-primary no-min-width st-btn-xs d-flex align-items-center justify-content-center"
                                                disabled={createCustomerButtonDisable}
                                            >
                                                <span className="text-uppercase ">
                                                    <FeatherIcon
                                                        icon="download"
                                                        size="14"
                                                        className="icon me-2" />
                                                    save</span>
                                            </Button>
                                        </div>
                                    </form>
                                </Col>
                            </div>
                        </div>
                    </div>
                    {
                        modalLoading && (
                            <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="border" />
                            </div>
                        )
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CustomerAddressModal)